// Sidebar.jsx
import "./Sidebar.css";
import React, { useState, useEffect } from "react";
import {
  FaHome,
  FaTachometerAlt,
  FaComments,
  FaCogs,
  FaProjectDiagram,
  FaPuzzlePiece,
  FaWhatsapp,
  FaUsersCog,
  FaChartBar,
  FaScroll,
  FaCog,
  FaChevronUp,
  FaChevronDown,
  FaRobot,
  FaFileImport,
  FaFileAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useAuthStore } from "../../services/useAuthStore";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";


const Sidebar = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  const [expanded, setExpanded] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const membership = useAuthStore((s) => s.membership);
  const canViewModule = useAuthStore((s) => s.canViewModule);
  const meLoaded = useAuthStore((s) => s.meLoaded);


  // Mapeia cada item do menu para o "module" que vem no /me
  const menuItems = [
    {
      icon: <FaHome />,
      label: "Home",
      path: "/",
      moduleKey: "dashboard",
    },
    {
      icon: <FaTachometerAlt />,
      label: "CRM",
      path: "/crm",
      moduleKey: "crm",
    },
    {
      icon: <FaFileAlt />,
      label: "CMS",
      path: "/cms",
      moduleKey: "cms",
    },
    {
      icon: <FaFileImport />,
      label: "Importacao em Massa",
      path: "/bulk-import",
      moduleKey: "crm",
    },
    {
      icon: <FaProjectDiagram />,
      label: "Fluxos Inteligentes",
      path: "/smartflow",
      moduleKey: "smart_flows",
    },
    {
      icon: <FaPuzzlePiece />,
      label: "Integrações",
      path: "/integrations",
      moduleKey: "integrations",
    },
    {
      icon: <FaWhatsapp />,
      label: "WhatsApp Automation",
      path: "/whatsapp",
      moduleKey: "whatsapp",
    },
    {
      icon: <FaUsersCog />,
      label: "Operações da Equipe",
      path: "/operationsteam",
      moduleKey: "team_operations",
    },
    {
      icon: <FaChartBar />,
      label: "Relatórios",
      path: "/relatorios",
      moduleKey: "reports",
    },
    {
      icon: <FaScroll />,
      label: "Logs",
      path: "/logs",
      moduleKey: "logs",
    },
    {
      icon: <FaRobot />,
      label: "Agente de IA",
      path: "/ai-agent",
      moduleKey: "ai_agent",
    },
    {
      icon: <FaCog />,
      label: "Configurações",
      path: "/configuracoes",
      moduleKey: "settings",
    },
  ];


  // Enquanto ainda não carregou /me, evita piscar menu errado
  // if (!meLoaded) {
  //   return <FullScreenLoader />;
  // }


  // Se não tem membership, provavelmente não está autenticado
  if (!membership) {
    return null;
  }


  const visibleItems = menuItems.filter((item) =>
    item.moduleKey ? canViewModule(item.moduleKey) : true
  );




  return (
    <>
      <div
        className={`sidebar ${expanded ? "expanded" : "collapsed"} ${mobileExpanded ? "mobile-expanded" : ""}`}
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
      >
        {isMobile && (
          <button 
            className="mobile-expand-btn"
            onClick={() => setMobileExpanded(!mobileExpanded)}
          >
            {mobileExpanded ? <FaChevronDown /> : <FaChevronUp />}
          </button>
        )}

        <div className="sidebar-logo">
          <img
            src={(!expanded && !isMobile) ? "/miniLogo.png" : "/logoFastTeam.png"}
            alt="Logo Fast Team"
            className={(!expanded && !isMobile) ? "logoPV logo-mini" : "logoPV"}
          />

        </div>


        <nav className="sidebar-menu">
          {visibleItems.map((item, index) => (
            <Link 
              key={index} 
              to={item.path} 
              className="sidebar-item"
              onClick={() => isMobile && setMobileExpanded(false)}
            >
              {item.icon}
              {!isMobile && expanded && <span>{item.label}</span>}
              {isMobile && <span className="sidebar-label">{item.label}</span>}
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
};


export default Sidebar;



